import React from 'react';
import JoinPage from '../../JoinPage';
import { withAuth } from '../../auth/withAuth';

const Join = () => {
  return <JoinPage />;
};

export default withAuth(Join);
